<div mat-dialog-title class="dialog-header">
  <h3 class="dialog-title">Setup Keys</h3>
  <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
</div>
<form [formGroup]="form" (ngSubmit)="onCreate()" class="account-auto-attendant-key-form">
  <mat-dialog-content class="account-auto-attendant-key-dialog-content">
    <lcs-responsive-table [columns]="columns">
      <table
        #table
        lcs-table
        [dataSource]="autoAttendantKeysArray.controls"
        formArrayName="autoAttendantKeysArray"
        class="keys-table"
        >
        <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
        <tr
          lcs-row
          *lcsResponsiveRowDef="let index = dataIndex"
          [hidden]="autoAttendantKeysArray.controls[index].value?.isDeleted"
        ></tr>

        <ng-container lcsColumnDef="keyNumber" [width]="2">
          <th lcs-header-cell *lcsHeaderCellDef>Key</th>
          <td lcs-cell *lcsCellDef="let index = dataIndex" [formGroupName]="index">
            <mat-form-field class="table-key-input">
              <input type="tel" matInput formControlName="keyNumber" [name]="'keyNumber' + index" />
              @if (autoAttendantKeysArray.controls[index]?.hasError('pattern', 'keyNumber')) {
                <mat-error
                  >Enter key 0-99, *0-*9, or #.</mat-error
                  >
                }
                @if (autoAttendantKeysArray.controls[index]?.hasError('unique', 'keyNumber')) {
                  <mat-error
                    >Duplicate keys not allowed.</mat-error
                    >
                  }

                  @if (autoAttendantKeysArray.controls[index]?.hasError('required', 'keyNumber')) {
                    <mat-error
                      >Field is required.</mat-error
                      >
                    }
                  </mat-form-field>
                </td>
              </ng-container>

              <ng-container lcsColumnDef="routeToExtension" [width]="4">
                <th lcs-header-cell *lcsHeaderCellDef>Route To</th>
                <td lcs-cell *lcsCellDef="let index = dataIndex" [formGroupName]="index">
                  <mat-form-field class="table-extension-select">
                    <input
                      class="empty-option-placeholder"
                      [lcsSingleSelect]="routeToExtensionSelect"
                      lcsStaticSelect
                      type="text"
                      formControlName="routeToExtension"
                      [name]="'routeToExtension' + index"
                      />
                      <lcs-static-select #routeToExtensionSelect [displayWith]="extensionDisplayWith">
                        <lcs-option [value]="'Name Directory'">Name Directory</lcs-option>
                        <lcs-option [value]="'Hangup'">Hangup</lcs-option>
                        @for (extension of addedExtensions; track extension) {
                          <lcs-option [value]="extension">
                            {{ extension.number }} - {{ extension.name }}
                          </lcs-option>
                        }
                      </lcs-static-select>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container lcsColumnDef="deleteKey" [width]="1">
                  <th lcs-header-cell class="button-class" *lcsHeaderCellDef>
                    <div class="ml-auto">
                      <button class="create-btn" type="button" mat-raised-button color="primary" (click)="onAddKey()"
                        >Add Key</button
                        >
                      </div></th
                      >
                      <td lcs-cell *lcsCellDef="let index = dataIndex" [formGroupName]="index">
                        <div class="delete-button-container">
                          <button
                            mat-icon-button
                            class="delete button"
                            type="button"
                            (click)="onDelete(autoAttendantKeysArray.controls[index].value, index)"
                            >
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </td>
                    </ng-container>
                  </table>
                </lcs-responsive-table>
              </mat-dialog-content>
              <mat-dialog-actions>
                <button type="submit" title="Add" mat-raised-button>Save</button>
              </mat-dialog-actions>
            </form>
